@import "@/scss/use-bootstrap-mixins";

.back_button {
  position: absolute;
  background-color: transparent;
  border: 0;
}

.nav {
  display: block !important;

  @include media-breakpoint-up(lg) {
    display: none !important;
  }
}

.navbarContainer {
  padding: 0 12px;
}

.header_content {
  width: 100%;
  height: 30px;
  display: block !important;

  @include media-breakpoint-up(lg) {
    display: none !important;
  }

  div {
    margin: 0 auto;
    width: fit-content;
    display: flex;
    height: 28px;
    align-items: center;
  }

  .marker {
  }

  .location {
    margin: 0;
    margin-left: 6px;
    font-size: 16px;
    font-weight: 600;
  }
}
